import { FC, useState } from 'react'
import styled from 'styled-components'
import alertBannerText from '../../_alert-banner.json'
import { Cross, PanelCross } from '../catalog/icons/Cross'
import { InjectedWindow } from '../../utils/types'
import { tabletSize } from '../catalog/screen-sizes'

declare const window: InjectedWindow

interface Props {}
export const AlertBanner: FC<Props> = () => {
  const [localDismissed, setLocalDismissed] = useState(false)
  const { message, display } = alertBannerText
  const dismissedByUser =
    window.applicationContext.dismissedAlertBanner === true

  const shouldDisplay = display && !dismissedByUser && !localDismissed

  return shouldDisplay ? (
    <Banner className={'banner-component'}>
      <div className={'banner'}>
        <p>{message}</p>
        <div className={'cross-wrapper'}>
          <PanelCross
            color="white"
            onClick={() => {
              window.applicationContext.dismissedAlertBanner = true
              setLocalDismissed(true)
            }}
            width={18}
          />
        </div>
      </div>
    </Banner>
  ) : null
}

const Banner = styled.div`
  width: 100%;
  min-height: 70px;
  background-color: #4015bc;
  color: white;
  display: flex;
  align-items: center;

  div.banner {
    display: flex;
    align-items: center;
    margin-right: 30px;
    width: 100%;
  }
  div.cross-wrapper {
    height: 100%;
    width: 100px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 1;
    span {
      width: 50px;
      display: flex;
    }

    svg {
      stroke: #191977;
      transform: scale(0.7);
    }
  }

  p {
    margin: 0;
    padding: 20px 30px 20px 50px;
    font-family: Montserrat;
    font-size: 16px;
    line-height: 22px;

    @media (max-width: ${tabletSize}) {
      padding-left: 20px;
    }
  }
`
